<template>
  <div>
    <!-- =========== End of Loader ============ -->

    <main class="main hidden">
      <!-- =========== Start of Navigation (main menu) ============ -->
      <header class="navbar navbar-expand-lg navbar-dark">
        <div class="container position-relative">
          <router-link to="/" class="navbar-brand">
            <img
              class="navbar-brand__regular"
              src="/assets/logo.png"
              alt="brand-logo"
              width="80px"
              height="80px"
            />
          </router-link>
          <!--  End of brand logo -->
        </div>
        <!-- end of container -->
      </header>
      <!-- =========== End of Navigation (main menu)  ============ -->

      <!-- =========== Start of Body ============ -->
      <section
        class="space bg-color--dark--1 h-min-100vh d-flex align-items-center"
      >
        <div class="svg-shape--top w-100 opacity--05">
          <img
            src="/assets/img/wave-8.svg"
            alt="wave"
            class="svg fill--white"
          />
        </div>
        <!-- end of whole area svg bg -->
        <div class="svg-shape--top opacity--10">
          <img src="assets/img/wave-9.svg" alt="wave" class="svg fill--white" />
        </div>
        <!-- end of top right mini svg shape -->

        <div class="container">
          <div class="row">
            <div class="col-12 mx-auto color--white text-center mb-4 mb-lg-5">
              <h1 class="h2-font mb-1 text-white">{{ $t("login.code") }}</h1>
            </div>
            <div class="col-12 col-sm-10 col-md-8 col-lg-7 col-xl-6 mx-auto">
              <div
                class="form--v5 bg-color--light--1 px-3 py-4 px-md-5 py-md-6 rounded--10"
              >
                <form action="#" class="form">
                  <div
                    class="alert alert-danger"
                    role="alert"
                    id="alert"
                    v-show="alert"
                  >
                    {{ err }}
                  </div>
                  <div class="form-group">
                    <!-- <label class="form__label text-uppercase font-size--15 font-w--500">{{$t("login.code")}}</label> -->

                    <input
                      id="otpCode"
                      v-model="otp_code"
                      type="number"
                      @wheel="$event.target.blur()"
                      class="form-control"
                      placeholder="کد فعال سازی را وارد کنید"
                      required
                    />
                    <div
                      class="text-color--400 font-size--10 mt-2 mt-sm-0 text-center"
                    >
                      <a
                        role="button"
                        type="button"
                        :disabled="counting"
                        @click="startCountdown"
                      >
                        <countdown
                          v-if="counting"
                          :time="120000"
                          @end="handleCountdownEnd"
                          class="text-color--400 font-size--10 mt-2 mt-sm-0 text-center"
                        >
                          <template slot-scope="props">
                            ارسال دوباره کد بعد از
                            {{ props.totalSeconds }} ثانیه
                          </template>
                        </countdown>
                        <span
                          class="text-color--400 font-size--10 mt-2 mt-sm-0 text-center"
                          v-else
                          ><a class="btn" role="button" @click="resentOtp">
                            ارسال دوباره کد</a
                          ></span
                        >
                      </a>
                    </div>
                  </div>

                  <div
                    class="d-flex justify-content-between flex-column-reverse flex-sm-row align-items-sm-center"
                  >
                    <router-link
                      to="sign-up"
                      class="text-color--400 font-size--15 mt-2 mt-sm-0"
                      >{{ $t("login.incorrectPhoneNumber") }}
                    </router-link>
                    <button
                      class="btn btn-bg--primary btn-size--md btn-hover--3d"
                      type="submit"
                      @click.prevent="checkOtp"
                    >
                      <span class="btn__text">{{ $t("login.login") }}</span>
                    </button>
                  </div>
                </form>
                <!-- end of form -->
              </div>
              <!-- end of from area -->
            </div>
            <!-- end of col -->
          </div>
          <!-- end of row -->
        </div>
        <!-- end of container -->
      </section>
      <!-- =========== End of Body ============ -->
    </main>
  </div>
</template>

<script>
// @ is an alias to /src

//import router from '../../router'

import Countdown from "@chenfengyuan/vue-countdown";
export default {
  name: "home",
  data() {
    return {
      alert: false,
      counting: true,
      otp_code: "",
      err: ""
    };
  },
  beforeCreate: function() {
    if (localStorage.getItem("mobile_number") == null) {
      this.$router.push("/sign-up");
    }
  },
  methods: {
    checkOtp() {
      const otp = {
        token: this.otp_code,
        mobile_number: localStorage.getItem("mobile_number")
      };
      this.$store
        .dispatch("checkOtp", otp)
        .then(() => {
          this.alert = false;
          this.$router.push("/base-register");
        })
        .catch(err => {
          this.alert = true;
          this.err = err.body.error;
          console.log(err);
        });
    },
    resentOtp() {
      this.$store
        .dispatch("resentOtp")
        .then(resp => {
          console.log(resp);
        })
        .catch(err => {
          console.log(err);
        });
    },
    startCountdown() {
      this.counting = true;
    },
    handleCountdownEnd() {
      this.counting = false;
    }
  },
  components: {
    // VueCountdown.name,
    Countdown
  }
};
</script>
<style scoped>
a {
  /* font-size: 0.9375rem; */
  font-size: 0.75rem;
  font-weight: 300;
}
</style>
